import { ActionBtnProps } from 'components/NewTable/types'
import * as React from 'react'
import { useEffect, useMemo, useState } from 'react'
import { IKeyword } from 'src/types/IKeyword'
import { useRemoveKeywordsMutation } from 'src/generated/graphql'
import { DropdownButton } from 'shared/ui/DropdownButton/DropdownButton'
import { Delete } from 'shared/assets/icons'
import { Button } from 'shared/ui/Button/Button'
import billingStore from 'store/settings/billing/billingStore'
import { MuiTooltip } from 'components/Tooltip/MuiTooltip'

export const KeywordDeleteBtn = (
  props: ActionBtnProps<IKeyword> & {
    id?: string
    ids?: string[]
    isDisabledByTrial?: boolean
  }
) => {
  const { row, id, ids, rows, isDisabledByTrial } = props

  const [removeKeywords] = useRemoveKeywordsMutation()
  const onDelete = async () => {
    try {
      const keywordIds =
        (row && [+row.id]) ||
        (id && [+id]) ||
        (ids && ids.map((id) => +id)) ||
        []
      if (keywordIds.length) {
        await removeKeywords({
          variables: {
            keywordIds,
          },
        })
        props.onSuccessAction?.()
      }
    } catch (e) {
      console.error(e)
    }
  }

  const [isConfirmDelete, setConfirmDelete] = useState(false)

  const text = isConfirmDelete ? 'Sure?' : 'Delete'
  const [idInterval, setIdInterval] = useState<NodeJS.Timeout | null>(null)
  const handleClick = () => {
    if (isConfirmDelete) {
      return onDelete()
    } else {
      setConfirmDelete(true)
      const id = setTimeout(() => {
        setConfirmDelete(false)
      }, 3000)
      setIdInterval(id)
    }
  }
  useEffect(() => {
    return () => {
      if (idInterval) {
        clearInterval(idInterval)
      }
    }
  }, [])

  const disabled = useMemo(() => {
    if (!billingStore.isTrial) return false
    if (isDisabledByTrial) return isDisabledByTrial
    let isDisabled = false
    if (row) {
      if (
        row?.keywordPhoneNumbers?.forEach((phone) => {
          if (phone?.phoneNumber?.type === 'TEST_TOLL_FREE') {
            isDisabled = true
          }
        })
      ) {
        isDisabled = true
      }
    }
    if (rows) {
      rows.forEach((row) => {
        row?.keywordPhoneNumbers?.forEach((phone) => {
          if (phone?.phoneNumber?.type === 'TEST_TOLL_FREE') {
            isDisabled = true
          }
        })
      })
    }
    return isDisabled
  }, [rows, row, billingStore.isTrial, isDisabledByTrial])

  const disabledTitle = 'Will be deleted after trial ends.'

  if (props.menu) {
    return (
      <DropdownButton
        variant={'quaternary'}
        fullWidth
        disabled={disabled}
        muiTooltipProps={
          disabled
            ? {
                title: disabledTitle,
                placement: 'left',
                arrow: true,
              }
            : undefined
        }
        LeftIcon={Delete}
        text={text}
        onClick={handleClick}
      />
    )
  }

  const btn = (
    <Button
      variant={'quaternary-medium'}
      LeftIcon={Delete}
      text={text}
      onClick={handleClick}
      disabled={disabled}
    />
  )

  if (disabled) {
    return (
      <MuiTooltip title={disabledTitle} placement={'top'} arrow>
        <div>{btn}</div>
      </MuiTooltip>
    )
  }

  return btn
}
